import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ScrollService {
  _scroll: Subject<any> = new Subject();
  _click: Subject<any> = new Subject();
  constructor() {}

  setScrollPosition(scrollposition) {
    this._scroll.next(scrollposition);
  }
  setClickEvent(e) {
    this._click.next(e);
  }
  getClickEvent() {
    return this._click;
  }
  getScrollPosition() {
    return this._scroll;
  }
}
